import React from 'react'
import { Hazard } from './GamePlay/hazards'
import TooltipFFXIV from '@/app/components/TooltipFFXIV'
import { useTranslation } from '@/hooks/useTranslation'

const HazardIcon = ({
    hazard,
    size = 40,
    tooltip = true,
    className = ''
}: {
    hazard: Hazard,
    size?: number,
    tooltip?: boolean,
    className?: string
}) => {
    const { t } = useTranslation();
    return (
        <div className='relative group'>
            <img
                src={hazard.icon}
                alt={hazard.name}
                width={size}
                className={className}
            />
            {tooltip && (
                <TooltipFFXIV>
                    {t(`hazards.${hazard.name}`)}
                </TooltipFFXIV>
            )}
        </div>
    )
}

export default HazardIcon